import { createSlice } from '@reduxjs/toolkit';
export const LOADING_FEATURE_KEY = 'loading';

export interface LoadingState {
  isLoading: boolean;
  requests: Array<any>;
}
const initialState: LoadingState = {
  isLoading: false,
  requests: Array<any>(),
};

export const loadingSlice = createSlice({
  name: LOADING_FEATURE_KEY,
  initialState: initialState,
  reducers: {
    startCall: (state, action) => {
      state.requests.push(action.payload);
      state.isLoading = true;
    },
    endCall: (state, action) => {
      const i = state.requests.indexOf(action.payload);
      if (i >= 0) {
        state.requests.splice(i, 1);
      }
      if (state.requests.length === 0) {
        state.isLoading = false;
      }
    },
    clear: (state) => {
      state.requests = Array<any>();
      state.isLoading = false;
    },
  },
});
export const loadingReducer = loadingSlice.reducer;
export const loadingActions = loadingSlice.actions;
